module.exports = __webpack_public_path__ + "img/macheenist.320d638f.png";